import React from 'react';

import Role from 'components/Tvendo/Setting/Role/List';

export default function () {
  return <Role />;
}
